export class Document {
  name: string = '';
  contents: string = '';
}
